import { appBaseUrl } from "utils/config";
import queryString from "query-string";
import { getService, postService, putService } from "services/commonServices";
import { isEmpty } from "lodash";

export class RotoCompanyService {
  getRotoCompanyPaginationListNew(body) {
    let url = `${appBaseUrl}/referenceManagement/companyList`;
    let data = postService(url, body);
    return data;
  }
}
